/**
 This directive is used in Backend management tables to indicate
 that a row is deletable.
 
 It will be responsible to show confirmation modal and handle with
 API calling and response
*/

import Vue from "vue";

export default {
  inserted: function(el, binding, vnode) {
    var deleteButtonComponent = Vue.extend({
      render: function(createElement) {
        return createElement("md-table-cell", [
          createElement(
            "md-button",
            {
              class: "md-icon-button md-white",
              on: {
                click: function() {
                  var confirmed = confirm("Are you sure?");

                  if (confirmed) {
                    var endpoint = vnode.context.endpoints.delete;
                    var data = vnode.parent.context.value;
                    var index = binding.value;
                    var item = data[index];

                    if (Number(item.id)) {
                      endpoint(vnode.context.$root.hotelId, item.id, error => {
                        if (!error) {
                          data.splice(index, 1);
                        }
                      });
                    } else {
                      data.splice(index, 1);
                    }
                  }
                }
              }
            },
            [createElement("md-icon", "delete")]
          )
        ]);
      }
    });

    var component = new deleteButtonComponent().$mount();
    el.appendChild(component.$el);
  }
};
